import { Core } from "@/core/Core";

export default {

  /* Modifiers groups */

  async getModifierGroups(context, {inventoryId, augment}) {
    try {
      return await Core.request("GET", `/api/inventory/${inventoryId}/modifier_groups`, {augment});
    } catch (e) {
      return null;
    }
  },

  async getModifierGroup(context, {inventoryId, id}) {
    try {
      return await Core.request("GET", "/api/inventory/" + inventoryId + "/modifier_groups/" + id);
    } catch (e) {
      return null;
    }
  },

  async createModifierGroup(context, {inventoryId, data}) {
    try{
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/modifier_groups", data);
    } catch (e) {
      return null;
    }
  },

  async saveModifierGroup(context, {inventoryId, itemId, data}) {
    try{
      return await Core.request("PUT", "/api/inventory/" + inventoryId + "/modifier_groups/" + itemId, data);
    } catch (e) {
      return null;
    }
  },

  async deleteModifierGroup(context, {inventoryId, id}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/modifier_groups/" + id);
    } catch(e) {
      return null;
    }
  },

  async saveModifierGroupsPriorities(context, {inventoryId, data}) {
    try{
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/modifier_groups/update-priority", data);
    } catch (e) {
      return null;
    }
  },
}